export const MAX_RESEND_ATTEMPTS = 2
